<template>
  <v-dialog v-model="dialog" max-width="1200px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <div class="edit" v-bind="attrs" v-on="on">
        <v-icon class="icon-item icon-note-edit-outline"></v-icon>
      </div>
    </template>
    <v-card>
      <v-card-text>
        <div class="list">
          <table>
            <thead>
            <tr>
              <th>Параметр</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <template v-if="indicator.isGroup">
              <tbody v-for="groupIndex in groups" :key="`group-${groupIndex}`">
              <tr class="group">
                <td>Группа ответов {{ groupIndex }}</td>
                <td colspan="2">
                  <v-btn
                      small
                      text
                      @click="removeGroup(groupIndex - 1)" :disabled="groups <= 1"
                  >
                    <v-icon small class="mr-1">mdi-delete</v-icon>
                    Удалить
                  </v-btn>
                </td>
              </tr>

              <tr v-for="(parameter, parameterIndex) in indicator.parameters" :key="'row-' + groupIndex + '-' + parameter.id">
                <td style="vertical-align: top;">{{ groupIndex }}.{{ parameterIndex + 1 }}. {{ parameter.name }}</td>
                <td style="vertical-align: top; width: 180px">
                  <div v-if="parameter.isFileNeeded || parameter.type === 'FILE'" style="color: #CF4520" >
                    Прикрепление файла обязательно
                  </div>
                  <div>Отчётная дата:<br>{{ parameter.recommendedEndDate | dateFormat }}</div>
                  <div>Дата изменения параметра в группах:<br>{{ getLastUpdatedDateTime(parameter) | dateFormat }}</div>
                </td>
                <td style="width: 100%">
                  <div class="d-flex align-center">
                    <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                      <path d="M8.94029 5.78581C8.59471 5.78581 8.31597 6.05336 8.31597 6.39919V15.4626C8.31597 16.388 7.98158 17.146 7.33488 17.7927C6.68819 18.4394 5.91905 18.7738 4.98271 18.7738C4.06847 18.7738 3.28814 18.4505 2.64147 17.8039C1.99481 17.1572 1.67158 16.3769 1.67158 15.4626V12.0402V10.2119V5.7078V3.54518V3.5228V3.50045C1.67158 2.88732 1.89728 2.35505 2.32943 1.91742C2.76705 1.47434 3.29908 1.23745 3.93481 1.23745C4.57031 1.23745 5.10259 1.47434 5.53993 1.91742C5.97208 2.35505 6.19781 2.88732 6.19781 3.50045V3.5228V3.5673V13.6791C6.19781 14.3143 5.70738 14.805 5.0719 14.805C4.45875 14.805 3.95693 14.2922 3.95693 13.6791V8.38343C3.95693 8.03785 3.68935 7.7703 3.3438 7.7703C2.99824 7.7703 2.73067 8.03785 2.73067 8.38343V13.6791C2.73067 14.3367 2.95375 14.8942 3.41064 15.3513C3.86776 15.8084 4.41408 16.0313 5.07193 16.0313C5.72953 16.0313 6.28152 15.8027 6.74413 15.3513C7.19579 14.9106 7.42413 14.3591 7.42413 13.6791V3.5228V3.50045C7.42413 2.54174 7.07569 1.71955 6.39857 1.03672C5.71572 0.348182 4.89352 0 3.93481 0C2.97587 0 2.15367 0.348182 1.47084 1.03672C0.793747 1.71955 0.445312 2.54174 0.445312 3.50045V3.5228V5.7078V10.2119V12.0402V15.4626C0.445312 16.7224 0.891247 17.7927 1.77195 18.6733C2.65266 19.554 3.72289 20 4.98271 20C6.24254 20 7.33488 19.5764 8.22678 18.6845C9.11865 17.7927 9.55342 16.7003 9.55342 15.4626V6.39919C9.55342 6.05336 9.28584 5.78581 8.94029 5.78581Z" fill="#777779"/>
                    </svg>

                    <input
                        type="file"
                        :id="getGroupFileId(parameter.id, groupIndex - 1)"
                        :key="getGroupFileId(parameter.id, groupIndex - 1)"
                        style="display:none"
                        @change="e => addGroupAttachment(parameter.id, groupIndex - 1, e.target.files[0])"
                    >
                    <template v-if="!getGroupValue(parameter.id, groupIndex - 1, 'FILES')">
                      <label :for="getGroupFileId(parameter.id, groupIndex - 1)" class="upload-link">
                        <i>Загрузить</i>
                      </label>
                    </template>
                    <template v-else>
                      <a @click="downloadAttachment(getGroupValue(parameter.id, groupIndex - 1, 'FILES'))">
                        {{ truncateStr(getGroupValue(parameter.id, groupIndex - 1, 'FILES')?.name, 50) }}
                      </a>
                      <a @click="deleteGroupAttachment(parameter.id, groupIndex - 1)" class="ml-2">
                        <v-icon class="icon-item icon-window-close"></v-icon>
                      </a>
                    </template>
                  </div>

                  <template v-if="parameter.type === 'STRING'">
                    <v-textarea
                        :value="getGroupValue(parameter.id, groupIndex - 1)"
                        @input="value => setGroupValue(parameter.id, groupIndex - 1, value)"
                        placeholder="Комментарий"
                    />
                    <span v-if="errorText[parameter.id + '_' + (groupIndex - 1)]" class="validate-error">
                          {{ errorText[parameter.id + '_' + (groupIndex - 1)] }}
                      </span>
                  </template>
                  <template v-else-if="parameter.type === 'NUMBER'">
                    <v-text-field
                        :value="getGroupValue(parameter.id, groupIndex - 1)"
                        @input="value => setGroupValue(parameter.id, groupIndex - 1, value)"
                        placeholder="Числовое значение"
                    />
                    <span v-if="errorText[parameter.id + '_' + (groupIndex - 1)]" class="validate-error">
                          {{ errorText[parameter.id + '_' + (groupIndex - 1)] }}
                      </span>
                  </template>
                  <template v-else-if="parameter.type === 'DATE'">
                    <div style="width:300px">
                      <DateField
                          labelName="Дата"
                          :dateValue="getGroupValue(parameter.id, groupIndex - 1)"
                          @minput="value => setGroupValue(parameter.id, groupIndex - 1, value)"
                      />
                    </div>
                  </template>
                  <template v-else-if="parameter.type === 'OPTIONAL' && parameter.options && parameter.options.length">
                    <v-select
                        class="report-select"
                        :menu-props="{ contentClass: 'report-select-menu', maxWidth: '640px' }"
                        :items="getParameterOptions(parameter)"
                        item-text="value" item-value="value"
                        :value="getGroupValue(parameter.id, groupIndex - 1)"
                        @input="value => setGroupValue(parameter.id, groupIndex - 1, value)"
                        placeholder="Выберите значение из списка"
                    >
                      <template #selection="{ item }">
                          <span class="report-select__selection" :title="getOptionText(item)">
                            {{ getOptionText(item) }}
                          </span>
                      </template>
                      <template #item="{ item }">
                          <span class="report-select__item" :title="getOptionText(item)">
                            {{ getOptionText(item) }}
                          </span>
                      </template>
                    </v-select>
                  </template>
                </td>
              </tr>

              <tr v-if="groupIndex === groups">
                <td colspan="3" class="text-right">
                  <v-btn @click="addGroup" small outlined>
                    <v-icon small class="mr-2">mdi-plus</v-icon>
                    Добавить группу ответов
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
            <template v-else>
              <tbody>
              <tr v-for="(parameter, parameterIndex) in indicator.parameters" :key="parameter.id">
                <td style="vertical-align: top;">{{ parameterIndex + 1 }}. {{ parameter.name }}</td>
                <td style="vertical-align: top; width: 150px">
                  <div v-if="parameter.isFileNeeded || parameter.type === 'FILE'" style="color: #CF4520">
                    Прикрепление файла обязательно
                  </div>
                  <div>
                    Отчётная дата:<br> {{ parameter.recommendedEndDate | dateFormat }}
                  </div>
                  <div>
                    Дата изменения:<br> {{ getLastUpdatedDateTime(parameter) | dateFormat }}
                  </div>
                </td>
                <td style="width: 100%">
                  <div class="d-flex align-center">
                    <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                      <path d="M8.94029 5.78581C8.59471 5.78581 8.31597 6.05336 8.31597 6.39919V15.4626C8.31597 16.388 7.98158 17.146 7.33488 17.7927C6.68819 18.4394 5.91905 18.7738 4.98271 18.7738C4.06847 18.7738 3.28814 18.4505 2.64147 17.8039C1.99481 17.1572 1.67158 16.3769 1.67158 15.4626V12.0402V10.2119V5.7078V3.54518V3.5228V3.50045C1.67158 2.88732 1.89728 2.35505 2.32943 1.91742C2.76705 1.47434 3.29908 1.23745 3.93481 1.23745C4.57031 1.23745 5.10259 1.47434 5.53993 1.91742C5.97208 2.35505 6.19781 2.88732 6.19781 3.50045V3.5228V3.5673V13.6791C6.19781 14.3143 5.70738 14.805 5.0719 14.805C4.45875 14.805 3.95693 14.2922 3.95693 13.6791V8.38343C3.95693 8.03785 3.68935 7.7703 3.3438 7.7703C2.99824 7.7703 2.73067 8.03785 2.73067 8.38343V13.6791C2.73067 14.3367 2.95375 14.8942 3.41064 15.3513C3.86776 15.8084 4.41408 16.0313 5.07193 16.0313C5.72953 16.0313 6.28152 15.8027 6.74413 15.3513C7.19579 14.9106 7.42413 14.3591 7.42413 13.6791V3.5228V3.50045C7.42413 2.54174 7.07569 1.71955 6.39857 1.03672C5.71572 0.348182 4.89352 0 3.93481 0C2.97587 0 2.15367 0.348182 1.47084 1.03672C0.793747 1.71955 0.445312 2.54174 0.445312 3.50045V3.5228V5.7078V10.2119V12.0402V15.4626C0.445312 16.7224 0.891247 17.7927 1.77195 18.6733C2.65266 19.554 3.72289 20 4.98271 20C6.24254 20 7.33488 19.5764 8.22678 18.6845C9.11865 17.7927 9.55342 16.7003 9.55342 15.4626V6.39919C9.55342 6.05336 9.28584 5.78581 8.94029 5.78581Z" fill="#777779"/>
                    </svg>
                    <template v-if="!findAttachment(parameter.id)">
                      <input type="file" :ref="parameter.id" style="display: none" @change="addAttachment(parameter.id, $event.target.files[0])">
                      <a @click="$refs[parameter.id][0].click()" class="upload-link"><i>Загрузить</i></a>
                    </template>
                    <template v-else>
                      <a @click="downloadAttachment(findAttachment(parameter.id))">
                        {{ truncateStr(findAttachment(parameter.id)?.name, 50) }}
                      </a>
                      <a @click="deleteAttachment(parameter.id)">
                        <v-icon class="icon-item icon-window-close"></v-icon>
                      </a>
                    </template>
                  </div>
                  <template v-if="parameter.type === 'STRING'">
                    <v-textarea
                        placeholder="Комментарий"
                        :value="getValue(parameter.id, 'VALUE')?.value"
                        @input="value => setValue(parameter.id, 'VALUE', value)"
                    ></v-textarea>
                    <span v-if="errorText[parameter.id]" class="validate-error">{{ errorText[parameter.id] }}</span>
                  </template>
                  <template v-if="parameter.type === 'NUMBER'">
                    <v-text-field
                        placeholder="Числовое значение"
                        :value="getValue(parameter.id, 'VALUE')?.value"
                        @input="value => setValue(parameter.id, 'VALUE', value)"
                    ></v-text-field>
                    <span v-if="errorText[parameter.id]" class="validate-error">{{ errorText[parameter.id] }}</span>
                  </template>
                  <template v-if="parameter.type === 'DATE'">
                    <div style="width: 300px">
                      <DateField
                          labelName="Дата"
                          :dateValue="getValue(parameter.id, 'VALUE')?.value"
                          @minput="value => setValue(parameter.id, 'VALUE', value)"
                      ></DateField>
                    </div>
                  </template>
                  <template v-if="parameter.type === 'OPTIONAL' && parameter.options && parameter.options.length > 0">
                    <v-select
                        class="report-select"
                        :menu-props="{ contentClass: 'report-select-menu', maxWidth: '640px' }"
                        placeholder="Выберите значение из списка"
                        :items="getParameterOptions(parameter)"
                        item-text="value"
                        item-value="value"
                        :value="getValue(parameter.id, 'VALUE')?.value"
                        @input="value => setValue(parameter.id, 'VALUE', value)"
                    >
                      <template #selection="{ item }">
                          <span class="report-select__selection" :title="getOptionText(item)">
                            {{ getOptionText(item) }}
                          </span>
                      </template>
                      <template #item="{ item }">
                          <span class="report-select__item" :title="getOptionText(item)">
                            {{ getOptionText(item) }}
                          </span>
                      </template>
                    </v-select>
                  </template>
                </td>
              </tr>
              </tbody>
            </template>
          </table>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            class="btn btn-outline"
            text
            @click="$emit('updated'); dialog = false"
        >
          Отмена
        </v-btn>
        <v-btn
            class="btn btn-primary"
            :disabled="loading"
            @click="submit()"
        >
          Сохранить изменения
        </v-btn>
      </v-card-actions>
    </v-card>
    <LoaderDialog :show="loading" msg="Загрузка"></LoaderDialog>
  </v-dialog>
</template>

<script>
import DateField from "@/components/elements/new/DateField";
import {downloadFile, uploadFile} from "@/modules/api.files";
import {saveIndicators} from "@/modules/api.indicators";
import LoaderDialog from "@/components/elements/LoaderDialog.vue";

export default {
  name: 'StandardReportEditDialog',
  props: ['report', 'indicator', 'values'],
  components: {LoaderDialog, DateField},
  data: () => ({
    dialog: false,
    loading: false,
    errorText: {},
    groups: 1,
    localValues: null,
  }),
  watch: {
    dialog(val) {
      if (val) {
        this.initValues();
        this.initGroups();
      }
    }
  },
  methods: {
    initValues() {
      this.localValues = JSON.parse(JSON.stringify(this.values || []));
    },
    initGroups() {
      if (!this.indicator?.isGroup) return;

      let maxLength = 1;
      for (const parameter of this.indicator.parameters) {
        ['VALUE', 'FILES'].forEach(type => {
          const record = this.getValue(parameter.id, type);
          const array = this.readArray(record?.value);
          if (this.hasGroupValue(array)) {
            let last = -1;
            for (let i = array.length - 1; i >= 0; i--) {
              if (array[i] !== null && array[i] !== '') {
                last = i;
                break;
              }
            }
            if (last >= 0) maxLength = Math.max(maxLength, last + 1);
          }
        })
      }
      this.groups = Math.max(maxLength, 1);
    },
    getValue(parameterId, type) {
      return this.localValues?.find(e => e.indicatorId === parameterId && e.type === type);
    },
    setValue(parameterId, type, val) {
      let value = this.getValue(parameterId, type)
      if (!value) {
        value = this.createEmptyValue(parameterId, type)
        this.localValues.push(value)
      }

      value.value = val
      this.$forceUpdate()
    },
    getGroupValue(parameterId, index, type = 'VALUE') {
      const record = this.getValue(parameterId, type);
      const array = this.readArray(record?.value);
      return array[index] ?? null;
    },
    setGroupValue(parameterId, index, val, type = 'VALUE') {
      const recordIndex = this.localValues.findIndex(e => e.indicatorId === parameterId && e.type === type);
      const record = recordIndex >= 0 ? this.localValues[recordIndex] : null;

      const parsed = this.readArray(record?.value);
      const base = Array.isArray(parsed) ? parsed.slice() : [];

      const needLen = Math.max(this.groups, index + 1);
      while (base.length < needLen) base.push(null);
      base[index] = val;

      const nextValue = this.hasGroupValue(base) ? JSON.stringify(base) : (type === 'FILES' ? '[]' : '');
      const nextValues = this.localValues.slice();

      if (recordIndex === -1) {
        nextValues.push({ ...this.createEmptyValue(parameterId, type), value: nextValue });
      } else {
        nextValues.splice(recordIndex, 1, { ...record, value: nextValue });
      }
      this.localValues = nextValues;
    },
    hasGroupValue(array) {
      return Array.isArray(array) && array.some(v => v !== null && v !== undefined && v !== '');
    },
    findAttachment(parameterId) {
      const attachmentsJson = this.getValue(parameterId, 'FILES')
      return attachmentsJson && attachmentsJson !== '[]' ? JSON.parse(attachmentsJson.value)[0] : null
    },
    async addAttachment(parameterId, attachment) {
      this.loading = true
      const fileInfo = await uploadFile(attachment);
      const attachedFile = [{ id: fileInfo.id, name: fileInfo.name }];

      this.setValue(parameterId, "FILES", JSON.stringify(attachedFile))
      this.loading = false
    },
    deleteAttachment(parameterId) {
      this.setValue(parameterId, "FILES", JSON.stringify([]))
    },
    async downloadAttachment(attachment) {
      this.loading = true
      await downloadFile(attachment.id, attachment.name)
      this.loading = false
    },
    async addGroupAttachment(parameterId, index, file) {
      if (!file) return;
      this.loading = true;
      try {
        const info = await uploadFile(file);
        this.setGroupValue(parameterId, index, {id: info.id, name: info.name}, 'FILES');
      } finally {
        this.loading = false;
      }
    },
    deleteGroupAttachment(parameterId, index) {
      this.setGroupValue(parameterId, index, null, 'FILES');
    },
    getLastUpdatedDateTime(parameter) {
      const value = this.getValue(parameter.id, "VALUE")?.updatedDateTime;
      const attachment = this.getValue(parameter.id, "FILES")?.updatedDateTime;

      if (value && attachment) {
        return new Date(Math.max(new Date(value).getTime(), new Date(attachment).getTime()));
      } else if (value) {
        return new Date(value);
      } else if (attachment) {
        return new Date(attachment);
      }
      return null
    },
    addGroup() {
      const newLength = this.groups + 1;
      for (const parameter of this.indicator.parameters) {
        ['VALUE', 'FILES'].forEach(type => {
          const record = this.getValue(parameter.id, type);
          if (record && record.value) {
            const array = this.readArray(record.value);
            while (array.length < newLength) array.push(null);
            record.value = JSON.stringify(array);
          }
        })
      }
      this.groups = newLength;
    },
    removeGroup(index) {
      const newLength = this.groups - 1;
      for (const parameter of this.indicator.parameters) {
        ['VALUE', 'FILES'].forEach(type => {
          const record = this.getValue(parameter.id, type);
          if (record && record.value) {
            const array = this.readArray(record.value);
            if (index >= 0 && index < array.length) array.splice(index, 1);
            while (array.length > newLength) array.pop();
            if (this.hasGroupValue(array)) record.value = JSON.stringify(array);
            else record.value = type === 'FILES' ? '[]' : '';
          }
        })
      }
      this.groups = newLength;
    },
    getGroupFileId(parameterId, group) {
      return `file_${parameterId}_${group}`;
    },
    createEmptyValue(parameterId, type) {
      return {
        indicatorId: parameterId,
        indicatorFormId: this.report.id,
        value: null,
        type: type,
        cznId: this.report.cznId,
        regionCode: this.report.regionCode,
        context: this.report.context,
        period: this.report.period,
      }
    },
    async submit() {
      this.validateValues()
      if (!this.isValidValuesList()) {
        this.$forceUpdate()
        return
      }
      this.loading = true
      let req = await saveIndicators(this.localValues)
      if (req.ok) {
        this.dialog = false;
        this.$emit('updated');
      }
      this.loading = false
    },
    isValidValuesList() {
      for (const k in this.errorText) {
        if (Object.prototype.hasOwnProperty.call(this.errorText, k)) {
          const v = this.errorText[k];
          if (v != null && v !== '') return false;
        }
      }
      return true;
    },
    validateValues() {
      this.errorText = {};

      if (this.indicator?.isGroup) {
        for (let groupIndex = 0; groupIndex < this.groups; groupIndex++) {
          for (const parameter of this.indicator.parameters) {
            const value = this.getGroupValue(parameter.id, groupIndex, 'VALUE');
            const key = `${parameter.id}_${groupIndex}`;
            this.errorText[key] = this.isValid(value, parameter.type);
          }
        }
      } else {
        for (const parameter of this.indicator.parameters) {
          const value = this.getValue(parameter.id, 'VALUE')?.value;
          this.errorText[parameter.id] = this.isValid(value, parameter.type);
        }
      }
    },
    isValid(value, type) {
      if (value == null || value === "") return null;

      if (type === 'NUMBER') {
        return this.isNumeric(value) ? null : 'Некорректное число';
      }
      if (type === 'STRING') {
        return String(value).length <= 4000 ? null : 'Длина текста не может превышать 4000 символов';
      }
      return null;
    },
    isNumeric(str) {
      if (typeof str != "string") return false
      let replacedCommaStr = Number(str.replace(/,/, '.'));
      return !isNaN(replacedCommaStr) && !isNaN(parseFloat(replacedCommaStr))
    },
    truncateStr(str, n) {
      if (str.length > (n + 6)) {
        return str.substring(0, n - 3) + "..." + str.substring(str.length - 6, str.length)
      }
      return str
    },
    getParameterOptions(parameter) {
      if (parameter.type === 'OPTIONAL' && parameter.options) {
        if (Array.isArray(parameter.options) && parameter.options.length > 0) {
          return parameter.options;
        }
      }
      return [];
    },
    getOptionText(item) {
      if (item == null) return '';
      if (typeof item === 'string') return item;
      if (typeof item === 'object') return item.value || item.text || '';
      return String(item);
    },
    readArray(raw) {
      if (!raw) return [];
      try {
        const array = JSON.parse(raw);
        return Array.isArray(array) ? array : [String(array)];
      } catch {
        return [];
      }
    },
  },
  filters: {
    dateFormat: function (date) {
      if (date == null || date === "") {
        return '—'
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },
}
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  th:nth-child(1),
  td:nth-child(1) {
    width: 330px;
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 170px;
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: auto;
  }
  th {
    border-bottom: 1px solid #E8E8E9;
    &:last-child {
      text-align: right;
      a {
        text-decoration: underline;
      }
      .v-btn {
        margin-left: 27px;
      }
    }
  }
  td {
    &:nth-child(2) {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-align: right;
      vertical-align: top;
      div {
        color: #777779;
        margin-bottom: 8px;
      }
    }
    &:last-child {
      vertical-align: top;
    }
  }
  .v-textarea textarea {
    height: 60px !important;
    padding: 10px !important;
  }
}
.v-dialog .v-card__actions .btn {
  width: auto !important;
}
.validate-error {
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  font-size: 12px;
  color: red;
}
.group {
  background-color: #f4f4f4;
}
.group td {
  padding: 8px !important;;
}
.upload-link {
  color: #0033a0;
  cursor: pointer;
}

.report-select {
  width: 700px;
  max-width: 100%;
  overflow: hidden;
}

.report-select::v-deep .v-input__slot,
.report-select::v-deep .v-select__slot,
.report-select::v-deep .v-select__selections {
  min-width: 0;
  overflow: hidden;
}

.report-select::v-deep .v-select__selections {
  display: flex;
  flex-wrap: nowrap;
}

.report-select::v-deep .v-select__selection--comma {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-select::v-deep input {
  min-width: 0 !important;
}

.report-select__selection,
.report-select__item {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-select__selection {
  flex: 1 1 auto;
  min-width: 0;
}

.report-select::v-deep .report-select-menu {
  max-width: 700px !important;
}

.report-select::v-deep .report-select-menu .v-list-item__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

